/**
 * Generated by orval. Do not edit manually.
 */

export type SubscriptionTier = (typeof SubscriptionTier)[keyof typeof SubscriptionTier]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubscriptionTier = {
  FREE: 'FREE',
  PREMIUM: 'PREMIUM',
  ELITE: 'ELITE',
  TRIAL: 'TRIAL',
  STARTER: 'STARTER',
  ULTRA: 'ULTRA',
} as const
